import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import axios from 'axios';
var moment = require('moment');

import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import RenderField from './RenderField.js';
import CustomSpinner from './CustomSpinner.js';
import CustomAlert from './CustomAlert.js';
import FlowProgressBar from './FlowProgressBar.js';
import Header from './Header.js';
import LeadInfo from './LeadInfo.js';
import AttributeOptions from './AttributeOptions.js';
import generateValidator from './Validations/generateValidator.js';


class PersonInformation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            code: '',
        };

    }

    componentDidMount() {
        this.props.setDefaultValue({
            obligated_person: "1",
            policital_exposed_person: "1",
        })
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        const obligated_person = [{id:0, name:'Si'}, {id:1 , name:'No'}]

        const policital_exposed_person = [{id:0, name:'Si'}, {id:1 , name:'No'}]

        return (
            <Section className="intro_form">
                <div className="row">
                    <Header>
                        <FlowProgressBar />
                        <FormattedHTMLMessage id="app.step_person_info" description="Persona info" />
                    </Header>
                    <div className='container no-gutters'>
                        <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                            <form onSubmit={handleSubmit(this.props.savePersonInformation)} className="pvc-form ">
                                {this.props.isLoading && <CustomSpinner message='Estamos buscando tu auto ideal' />}
                                {error && <CustomAlert bsStyle="danger" message={error} />}
                                <div className="row">
                                    <div className="form-group horizontal-group">
                                        <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9 text-left horizontal-label">
                                            <label>
                                                ¿Es Sujeto Obligado?
                                            </label>
                                        </div>
                                        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 text-center horizontal-field">
                                            <AttributeOptions name="obligated_person" attributeName='obligated_person' attributeOptions={obligated_person} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form-group horizontal-group">
                                        <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9 text-left horizontal-label">
                                            <label>
                                                ¿Alcanzado como Persona Expuesta Políticamente?
                                            </label>
                                        </div>
                                        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 text-center horizontal-field">
                                            <AttributeOptions name="policital_exposed_person" attributeName='policital_exposed_person' attributeOptions={policital_exposed_person} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

let validate = generateValidator([{name: 'obligated_person', required: true}, {name: 'policital_exposed_person', required: true} ]);

PersonInformation = TopScrolleable(PersonInformation);

PersonInformation = reduxForm({
    form: 'PersonInformationForm', // a unique name for this form
    validate
})(PersonInformation);

PersonInformation = LeadInfo(PersonInformation);
//PersonInformation = withAuthControl(PersonInformation);

export default PersonInformation;



/** WEBPACK FOOTER **
 ** ./src/components/PersonInformation.js
 **/